/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

sticky-js - Does exactly what you would expect.

https://rgalus.github.io/sticky-js/

*/

import Sticky from 'sticky-js';

function initStickyJs() {

    const sticky = new Sticky('.calculator-plugin__col-2');

}

$(function(){

    // on page load
    initStickyJs();

});



// WEBPACK FOOTER //
// ./static/js/modules/sticky.js